export const IS_MAC = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
